<script>
import { Doughnut } from "vue-chartjs/legacy";
export default {
  extends: Doughnut,
  name: "round-chart",
  props: ["options", "chartData", "nostyle", "oncolors"],
  mounted() {
    this.renderChart(this.setGraphConfig(this.chartData), this.options);
  },
  watch: {
    chartData() {
      this.renderChart(this.setGraphConfig(this.chartData), this.options);
    }
  },
  methods: {
    RandomColor() {
      var letters = "0123456789ABCDEF".split("");
      var colors = ["#b51d2f", "#2B2D42", "#8D99AE"];
      for (var x = 0; x < this.chartData.labels.length; x++) {
        var color = "#";
        for (var i = 0; i < 6; i++) {
          color += letters[Math.floor(Math.random() * 16)];
        }
        colors.push(color);
      }
      return colors;
    },
    setGraphConfig(dataToChange) {
      if (!this.nostyle) {
        Object.values(dataToChange.datasets).forEach(data => {
          data["weight"] = 10;
          data["backgroundColor"] = this.RandomColor();
        });
      }

      if(this.oncolors){
        Object.values(dataToChange.datasets).forEach(data => {
          data["weight"] = 10;
          data["backgroundColor"] = this.oncolors;
        });
      }
      
      return dataToChange;
    }
  }
};
</script>
